import type { ReactNode } from "react";

import { useGrowthFormDraftOwner } from "./GrowthFormDraftBoundary";

import SimpleProtectedRoute from "@/components/auth/SimpleProtectedRoute";

/** Pass only a definitive, actor-bound claim denial to retained form custody. */
export function GrowthFormClaimGate({
  children,
  requiredClaims,
}: {
  children: ReactNode;
  requiredClaims: string[];
}) {
  const owner = useGrowthFormDraftOwner();
  return (
    <SimpleProtectedRoute
      onDefinitiveClaimDenial={owner?.retireOnClaimDenial}
      requiredClaims={requiredClaims}
    >
      {children}
    </SimpleProtectedRoute>
  );
}
